import { styled, Chip, chipClasses } from '@mui/material';

import { CopyButton } from '~components/index';

export const TrackingOrderPageInfoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const TrackingOrderPageInfoChip = styled(Chip)(({ theme }) => ({
  padding: theme.spacing(0, 1.25),
  borderRadius: Number(theme.shape.borderRadius) * 2,

  [`& .${chipClasses.icon}`]: {
    margin: 0,
    marginRight: theme.spacing(1),
    fontSize: theme.typography.pxToRem(11),
  },

  [`& .${chipClasses.label}`]: {
    padding: 0,
  },
}));

export const TrackingOrderPageInfoCopyButton = styled(CopyButton)(
  ({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0.75),
    fontSize: theme.typography.pxToRem(14),

    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
);
